<template>
  <div class="address-info">
    <van-icon class="address-icon" :name="getImageUri('/img/address-icon@2x.png')" size="0.55rem"></van-icon>
    <div class="address-content" v-if="isLink">
      <p class="address-content-l">收货人: {{ selectAddress.contactPerson }}</p>
      <p class="address-content-l">联系号码: {{ selectAddress.contactMobile }}</p>
      <p class="address-content-l">收货地址:
        {{selectAddress.provinceName}}{{selectAddress.cityName}}{{selectAddress.countyName}}{{
        selectAddress.detailAddress }}</p>
    </div>
    <div class="address-content" v-else>
      <p class="address-content-l">收货人: {{ selectAddress.receivePerson }}</p>
      <p class="address-content-l">联系号码: {{ selectAddress.receivePhone }}</p>
      <p class="address-content-l">收货地址:
        {{selectAddress.provinceName}}{{selectAddress.cityName}}{{selectAddress.countyName}}{{
        selectAddress.detailAddress }}</p>
    </div>
    <van-button class="exchange-button" size="mini" type="primary" plain
      v-if="selectAddress.orderStatus === '10' || isLink" @click="goToReceivingAddress">修改地址</van-button>
    <PopupAddress ref="popupAddress" @setLocation="setLocation"></PopupAddress>
    <van-popup v-model="popShow" class="msg-pop" :close-on-click-overlay="false">
      <van-form @submit="onSubmit" :show-error="false">
        <van-field v-model="location" name="请选择城市" label="请选择城市" placeholder="点击选择城市"
          :rules="[{ required: true, message: '请输入城市' }]" @focus="$refs.popupAddress.open(provinceId,cityId,countyId)" readonly />
        <van-field v-model.trim="detailAddress" label="详细地址" placeholder="请输入详细地址" type="textarea"
          :rules="[{ required: true, message: '请输入详细地址' }]"  maxlength="50"  show-word-limit  autosize/>
        <div class="bottom-button">
          <van-button @click="popShow = false" native-type="button">取消</van-button>
          <van-button type="primary" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import PopupAddress from '@/components/popup-address.vue'
import centerApi from '@/api/center'
export default {
  props: {
    selectAddress: {
      type: Object,
      default: () => { }
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PopupAddress
  },
  data () {
    return {
      popShow: false,
      location: '',
      detailAddress: '',
      provinceId: '',
      cityId: '',
      countyId: ''
    }
  },
  computed: {
  },
  methods: {
    init () {
      this.provinceId = this.selectAddress.provinceId
      this.cityId = this.selectAddress.cityId
      this.countyId = this.selectAddress.countyId
      this.detailAddress = this.selectAddress.detailAddress
      this.location = this.selectAddress.provinceName + this.selectAddress.cityName + this.selectAddress.countyName
    },
    getImageUri (mobileImageUri) {
      return process.env.VUE_APP_EXTRA_SITE + mobileImageUri
    },
    goToReceivingAddress () {
      if (this.selectAddress.orderStatus === '10') {
        this.init()
        this.popShow = true
        return
      }
      if (this.isLink) {
        this.$emit('handle')
      }
    },
    setLocation (value) {
      this.provinceId = value.provinceId
      this.cityId = value.cityId
      this.countyId = value.countyId
      this.location = value.location
    },
    onSubmit () {
      let data = {
        orderId: this.selectAddress.orderId,
        provinceId: this.provinceId,
        cityId: this.cityId,
        countyId: this.countyId,
        detailAddress: this.detailAddress
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      centerApi.updateDetailAddress(data).then(res => {
        if (res.data.resultCode === '0') {
          this.$toast('修改地址成功')
          this.popShow = false
          this.$emit('refreshData')
        } else {
          this.$toast.clear()
        }
      }).catch(() => { this.$toast.clear() })
    }
  }
}
</script>
<style scoped lang="less">
.address-info {
  font-size: 0.35rem;
  padding: 0.3rem;
  display: flex;
  background-color: #fff;
  align-items: center;
  min-height: 2rem;

  .address-content {
    flex: 1 1 auto;
    margin: 0 0.4rem;

    .address-content-l {
      margin: 0.2rem 0rem;
    }
  }
}
.exchange-button {
  font-size: 0.35rem;
  width: 1.75rem;
  padding: 0rem;
  flex-shrink: 0;
}
.msg-pop {
  width: 80%;
  // height: 135px;
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;
  padding: 8px;
  .msg-text {
    font-size: 14px;
    margin-top: 10px;
    color: #402d26;
    line-height: 22px;
  }
  .bottom-button{
    display: flex;
    button{
      width: 50%;
    }

  }
}

</style>
